export function getQuery() {
  const result = {}
  const query = window.location.search.split('?')[1]
  if (query) {
    const queryArr = query.split('&')
    queryArr.forEach(item => {
      const value = item.split('=')[1]
      const key = item.split('=')[0]
      const results = result as any
      results[key] = value
    })
  }
  return result
}